import { CardGrid } from '@iheartjane/menu';
import {
  Box,
  Button,
  Flex,
  Skeleton,
  Typography,
  useMobileMediaQuery,
} from '@iheartjane/reefer';
import { pluralize } from '@iheartjane/utils';

import {
  DEFAULT_DESKTOP_CARD_WIDTH,
  DEFAULT_DESKTOP_VB_DESCRIPTION_CARD_WIDTH,
} from '@jane/shared/components';

import type { MenuProductGridProps } from './menuProductGrid.types';

export const MenuProductGrid = ({
  children,
  hasVirtualBudtenderDescription = false,
  hasMore,
  hideTotal = false,
  isLoading,
  isLoadingMore,
  listView = false,
  name,
  onViewMoreClick,
  totalRenderedProducts = 0,
  totalResults,
  ...props
}: MenuProductGridProps) => {
  const isMobile = useMobileMediaQuery({});
  const resultsCount = totalResults || 0;
  const resultsLabel = pluralize({
    kilo: true,
    noun: 'product',
    number: resultsCount,
  });

  const numberOfSkeletons = listView
    ? totalRenderedProducts + 8
    : totalRenderedProducts + 20;

  const minCardWidth = hasVirtualBudtenderDescription
    ? DEFAULT_DESKTOP_VB_DESCRIPTION_CARD_WIDTH
    : DEFAULT_DESKTOP_CARD_WIDTH;

  const mobileColumns = hasVirtualBudtenderDescription ? 1 : 2;

  return (
    <Flex flexDirection="column" width="100%" alignItems="center" {...props}>
      {!hideTotal && isLoading && (
        <Box mr="auto">
          <Skeleton.Bone mb={24} width={150} />
        </Box>
      )}
      {!hideTotal && !isLoading && (
        <Typography color="text-light" textAlign="left" width="100%" mb={24}>
          {resultsLabel}
        </Typography>
      )}

      <CardGrid
        minCardWidth={minCardWidth}
        mobileColumns={mobileColumns}
        listView={listView}
      >
        {isLoading
          ? Array.from({ length: numberOfSkeletons }, (_, i) => (
              <Skeleton.Bone
                height={!listView ? (isMobile ? 425 : 475) : 145}
                width="100%"
                key={i}
                mb={!listView ? 32 : 0}
              />
            ))
          : children}
      </CardGrid>
      {!isLoading && hasMore && (
        <Button
          aria-label={`${name} View more`}
          label="View more"
          onClick={onViewMoreClick}
          full={isMobile}
          mt={isMobile ? 24 : 48}
          loading={isLoadingMore}
        />
      )}
    </Flex>
  );
};
